<template>
  <div class="footer-container">
    <div class="footer">
      <slot></slot>
    </div>
    <div class="footer-block"></div>
  </div>
</template>

<script>
export default {
    name: 'page-footer',
    props:{
        justify: {
            type: String,
            default: 'end'
        }
    },
    data(){
        return {

        }
    }
}
</script>

<style lang="scss" scoped>
    .footer {
        box-shadow: 0px -3px 10px rgba(0, 0, 0, 0.0980392156862745);
        display: flex;
        align-items: center;
        justify-content: center;
        width: calc(100vw - 256px);
        height: 70px;
        padding: 0 20px;
        position: fixed;
        right: 26px;
        left: 230px;
        bottom: 0;
        background-color: #fff;
        border-radius: 0 0 20px 20px;
        z-index: 10;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
        transition: left .6s, right .6s, width .6s;
    }
    .footer-block {
        height: 90px;
    }
    #app .hide-sidebar .main-container .footer {
        width: calc(100vw - 110px);
        left: 84px;
    }
</style>
